import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

const getInitial = () => {
  try {
    const saved = localStorage.getItem("a4a_lang");
    if (saved && translations[saved]) return saved;
  } catch (e) {}
  return "it";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitial);

  useEffect(() => {
    try {
      localStorage.setItem("a4a_lang", lang);
      document.documentElement.lang = lang;
    } catch (e) {}
  }, [lang]);

  // t('home.title') -> string, falls back to key if missing
  const t = (path) => {
    const parts = path.split(".");
    let node = translations[lang];
    for (const p of parts) {
      if (node && typeof node === "object" && p in node) node = node[p];
      else return path;
    }
    return node;
  };

  // pick localized value from a { it, en } object
  const pick = (obj) => {
    if (!obj) return "";
    if (typeof obj === "string") return obj;
    return obj[lang] ?? obj.it ?? "";
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, pick }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
